import index from '../sections/home/Home'
export default index
